module.exports = __webpack_public_path__ + "img/logo.6fa90eb4.png";